export const peripheryAddresses = {
  adaptiveCurveIRMFactory: "0x13703f8E7bAa5c99Fc9CD9EE1976dC7B562e5183",
  capRiskStewardFactory: "0x4eDf90a4C5d61f6415A58B3eD5b305A8b42D7c0f",
  edgeFactory: "0x29f43F6C0425D97250D2e529c35feDa81d35c3ac",
  edgeFactoryPerspective: "0x9bA5a13C6C11480F9B55E5065591E31e28379B6b",
  escrowedCollateralPerspective: "0x68e59139e687a45939a7504023C43d3157D28EA5",
  eulerEarnFactoryPerspective: "0xab72CAbDAF63b5559c358A212720119EB5108E7e",
  eulerEarnGovernedPerspective: "0x8bf670A110f267307a421E5C9754d0F1E9903A66",
  eulerEarnPublicAllocator: "0x4873ff8a70aA92443321Edb34a48f6aBfA7feB96",
  eulerUngoverned0xPerspective: "0xFAea47832Fd23d4BB3E3208061b76E765bAa8dBA",
  eulerUngovernedNzxPerspective: "0x0015d2177BF1B05648A9C39369706c8938822cbF",
  evkFactoryPerspective: "0xC194A7A86592C712BC155979A233B3d6F00e604a",
  externalVaultRegistry: "0xCe790A1800a54Ff2c558E2de0aaaA72243B4eF6c",
  feeCollector: "0x0000000000000000000000000000000000000000",
  feeFlowController: "0x9128754f3951a819528d110f3a92a2586D352463",
  feeFlowControllerUtil: "0xb4b59CBD3052bA035540a42C049E7E305198534e",
  fixedCyclicalBinaryIRMFactory: "0x2d4Efa10E128FbA4209D04866D7A732E8DceE453",
  governedPerspective: "0xb5B6AD9d08a2A6556C20AFD1D15796DEF2617e8F",
  governorAccessControlEmergencyFactory:
    "0x38d17d931FC1b6D79142Ba00e8F8ea89952cD2AB",
  irmRegistry: "0x71c4b9225Baaff7544a5bB29C9131365aD16Baa0",
  kinkIRMFactory: "0x80727c2F6A2cc64D19Ca5B7614b4bf826Dd95DcC",
  kinkyIRMFactory: "0x858F7F1FBB823eB97a300a31833DfAE7CA7Ec24A",
  oracleAdapterRegistry: "0xE5441e9F93A9068E9a3085A2CbD33E44De56F3e3",
  oracleRouterFactory: "0x0512F7cbc4Fd9d8BC47FfFa3aA0372bA2375158E",
  swapVerifier: "0x5a8610DB17CfF800C8abEb6Da31B9bB1fF51843f",
  swapper: "0x5ff07e50D83769861db40C5087753124D389c1c0",
  termsOfUseSigner: "0x03C4A1b8b860Dd98fB3fc03c8D693EAbABC667c5",
} as const
